import { $, $$, onReady, isMobile, reducedMotion } from '../nth-ms26-core/js/env';
import { open as openModal } from '../nth-ms26-modal/nth-ms26-modal';

/*
 * Màn Chu niên (màn 2 trang chủ, /#chu-nien): 7 mục dạng tab (PC thanh trên, MB thanh ở đáy màn),
 * mỗi mục có phân trang riêng, thẻ bấm mở popup mô tả lấy từ <template class="adetail">,
 * lịch MB kéo ngang có thanh cuộn kiểu PSD.
 */

function initTabs(root) {
  const panels = $$('[data-tab-panel]', root);
  const ids = panels.map((p) => p.dataset.tabPanel);
  const buttons = () => $$('[data-tab-btn]', root);

  function select(id, { focus = false, scroll = true } = {}) {
    if (!ids.includes(id) || root.dataset.tab === id) return;
    root.dataset.tab = id;
    panels.forEach((p) => {
      p.hidden = p.dataset.tabPanel !== id;
    });
    buttons().forEach((b) => {
      const on = b.dataset.tabBtn === id;
      b.setAttribute('aria-selected', String(on));
      b.tabIndex = on ? 0 : -1;
      if (on && focus) b.focus();
    });
    // MB: bấm thanh mục ở đáy màn → cuộn về đầu màn để thấy tiêu đề mục mới
    if (scroll && isMobile()) {
      const top = root.getBoundingClientRect().top;
      if (top < 0) window.scrollTo({ top: window.scrollY + top, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }
    document.dispatchEvent(new CustomEvent('nth:anniv-tab', { detail: { id } }));
  }

  root.addEventListener('click', (e) => {
    const b = e.target.closest('[data-tab-btn]');
    if (b) select(b.dataset.tabBtn);
  });
  // ← → Home End trong thanh tab (chuẩn ARIA tabs); chặn lan lên fullpage (Home/End = nhảy màn)
  root.addEventListener('keydown', (e) => {
    const b = e.target.closest && e.target.closest('[data-tab-btn]');
    if (!b) return;
    const i = ids.indexOf(b.dataset.tabBtn);
    const to = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: ids.length - 1 }[e.key];
    if (to === undefined) return;
    e.preventDefault();
    e.stopPropagation();
    select(ids[(to + ids.length) % ids.length], { focus: true, scroll: false });
  });
}

// Phân trang: data-per (PC) / data-per-mb (MB) phần tử mỗi trang; data-slide-mb = MB trượt ngang từng phần tử (phiếu Ngoại trang)
function initPager(el) {
  const list = $('[data-pager-list]', el);
  const items = $$('[data-pager-item]', el);
  if (!list || !items.length) return;
  const mobile = isMobile();
  const per = Math.max(1, parseInt(mobile ? el.dataset.perMb : el.dataset.per, 10) || 1);
  const slide = mobile && el.hasAttribute('data-slide-mb');
  const pages = Math.ceil(items.length / per);
  const dotsBox = $('[data-pager-dots]', el);
  const dots = [];
  let page = -1;

  el.classList.toggle('is-single', pages < 2);
  if (dotsBox) {
    for (let i = 0; i < pages; i += 1) {
      const d = document.createElement('button');
      d.type = 'button';
      d.className = 'apager__dot';
      d.setAttribute('aria-label', `Trang ${i + 1}`);
      d.addEventListener('click', () => go(i));
      dotsBox.appendChild(d);
      dots.push(d);
    }
  }

  function go(p) {
    const next = (p + pages) % pages;
    if (next === page) return;
    page = next;
    if (slide) {
      list.style.setProperty('--i', page);
      items.forEach((it, i) => {
        it.classList.toggle('is-current', i === page);
        it.inert = i !== page;
      });
      const img = items[page + 1] && $('img[loading="lazy"]', items[page + 1]);
      if (img) img.loading = 'eager';
    } else {
      let n = 0;
      items.forEach((it, i) => {
        const on = Math.floor(i / per) === page;
        it.hidden = !on;
        it.classList.remove('is-enter');
        if (on) it.style.setProperty('--n', n++);
      });
      // chạy lại hiệu ứng hiện dần cho trang mới
      requestAnimationFrame(() => items.forEach((it) => !it.hidden && it.classList.add('is-enter')));
    }
    dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === page);
      if (i === page) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }

  const prev = $('[data-pager-prev]', el);
  const nextBtn = $('[data-pager-next]', el);
  if (prev) prev.addEventListener('click', () => go(page - 1));
  if (nextBtn) nextBtn.addEventListener('click', () => go(page + 1));

  // vuốt ngang ≥ 50px đổi trang; chặn click mở thẻ nếu vừa vuốt
  let x0 = null;
  let y0 = 0;
  let swiped = false;
  list.addEventListener('pointerdown', (e) => {
    x0 = e.clientX;
    y0 = e.clientY;
    swiped = false;
  });
  list.addEventListener('pointerup', (e) => {
    if (x0 === null || pages < 2) return;
    const dx = e.clientX - x0;
    x0 = null;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(e.clientY - y0)) {
      swiped = true;
      go(page + (dx < 0 ? 1 : -1));
    }
  });
  list.addEventListener('click', (e) => {
    if (!swiped) return;
    e.preventDefault();
    e.stopPropagation();
    swiped = false;
  }, true);
  list.addEventListener('dragstart', (e) => e.preventDefault());

  go(0);
}

// Popup mô tả: chép nội dung <template class="adetail"> của thẻ vừa bấm
function initDetail() {
  const modal = $('#anniv-popup');
  const body = modal && $('[data-popup-body]', modal);
  if (!body) return;
  let seq = 0;
  document.addEventListener('click', (e) => {
    const hit = e.target.closest('[data-detail]');
    if (!hit) return;
    const tpl = hit.closest('li') && $('template.adetail', hit.closest('li'));
    if (!tpl) return;
    e.preventDefault();
    body.replaceChildren(tpl.content.cloneNode(true));
    const title = $('.adetail__title', body);
    if (title) {
      title.id = `adetail-title-${++seq}`;
      modal.setAttribute('aria-labelledby', title.id);
      modal.removeAttribute('aria-label');
    }
    $$('.adetail__text', body).forEach((t) => { t.scrollTop = 0; });
    openModal(modal);
    const close = $('[data-popup-close]', modal);
    if (close) setTimeout(() => close.focus({ preventScroll: true }), 60);
  });
}

// Lịch MB: kéo ngang bằng chuột (máy bàn thu nhỏ) + thanh cuộn tự vẽ theo PSD
function initCalendar(root) {
  const cal = $('[data-cal]', root);
  const scroller = cal && $('[data-cal-scroll]', cal);
  const thumb = cal && $('[data-cal-thumb]', cal);
  if (!scroller || !thumb || !isMobile()) return;
  const bar = thumb.parentElement;

  const sync = () => {
    if (!scroller.clientWidth) return; // mục Lịch đang ẩn
    const max = scroller.scrollWidth - scroller.clientWidth;
    const track = bar.clientWidth;
    const w = Math.max(60, (track * scroller.clientWidth) / scroller.scrollWidth);
    thumb.style.width = `${w}px`;
    thumb.style.transform = `translateX(${max > 0 ? ((track - w) * scroller.scrollLeft) / max : 0}px)`;
  };
  scroller.addEventListener('scroll', sync, { passive: true });
  document.addEventListener('nth:anniv-tab', (e) => {
    if (e.detail.id === 'lich') requestAnimationFrame(sync);
  });
  window.addEventListener('resize', sync);
  sync();

  let start = null;
  scroller.addEventListener('pointerdown', (e) => {
    if (e.pointerType !== 'mouse') return;
    start = { x: e.clientX, left: scroller.scrollLeft };
    scroller.classList.add('is-drag');
    scroller.setPointerCapture(e.pointerId);
  });
  scroller.addEventListener('pointermove', (e) => {
    if (!start) return;
    // toạ độ chuột là px màn hình, scrollLeft là px thiết kế (trang đã scale) → quy đổi
    const k = scroller.getBoundingClientRect().width / scroller.offsetWidth || 1;
    scroller.scrollLeft = start.left - (e.clientX - start.x) / k;
  });
  const end = () => {
    start = null;
    scroller.classList.remove('is-drag');
  };
  scroller.addEventListener('pointerup', end);
  scroller.addEventListener('pointercancel', end);
}

// PC: màn chỉ có bản tối → sidebar dùng token tối khi đang đứng ở màn này (theme Sáng thì chữ/icon menu chìm vào nền).
// Chừa nút Sáng/Tối: nó phải hiện đúng theme thật của trang.
function syncSidebarTheme(root) {
  const parts = $$('.sidebar__panel, .sidebar__logo, .sidebar .menu, .sidebar .sound-toggle, .sidebar__social');
  if (!parts.length) return;
  document.addEventListener('nth:frame', (e) => {
    const on = e.detail.frame === root && !e.detail.drawer;
    parts.forEach((el) => (on ? el.setAttribute('data-theme', 'dark') : el.removeAttribute('data-theme')));
  });
}

onReady(() => {
  const root = $('[data-anniv]');
  if (!root) return;
  syncSidebarTheme(root);
  // vùng chữ dài: lăn chuột cuộn bên trong trước, tới mép mới chuyển màn (fullpage đọc data-scrollable)
  $$('.afeat__info', root).forEach((el) => el.setAttribute('data-scrollable', ''));
  initTabs(root);
  $$('[data-pager]', root).forEach(initPager);
  initDetail();
  initCalendar(root);
});
